/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import { showModal, getCertificate } from "actions";
// import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { ReactComponent as SvgDownloadCertificate } from "components/widgets/training/download-certificate.svg";
import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";
import "components/widgets/training/Training.css";
import TrainingDetailDocuments from "./TrainingDetailDocuments";
import { SCORMURL, LANGUAGE_CODES, LANGUAGES, ENV_NAME } from "util/constant";
import { Trans } from "react-i18next";
import i18n from "i18next";
import Helpers from "util/helpers";
import { Dropdown } from "react-bootstrap";

import { ReactComponent as UKFlag } from "components/widgets/language/flag-united-kingdom.svg";
import { ReactComponent as UAEFlag } from "components/widgets/language/flag-united-arab-emirates.svg";
import { ReactComponent as FRFlag } from "components/widgets/language/flag-france.svg";
import { ReactComponent as DEFlag } from "components/widgets/language/flag-germany.svg";
import { ReactComponent as RUFlag } from "components/widgets/language/flag-russia.svg";
import { ReactComponent as ESFlag } from "components/widgets/language/flag-spain.svg";
import { ReactComponent as TRFlag } from "components/widgets/language/flag-turkey.svg";
import { ReactComponent as HRFlag } from "components/widgets/language/flag-croatian.svg";

class CompletedTraining extends Component {
  state = {
    showingChildren: false,
    selectedTrainingLanguage: null,
  };

  constructor(props) {
    super(props);
    this.trainingNameRef1 = React.createRef();
    this.trainingNameRef2 = React.createRef();
  }

  componentDidMount() {
    // console.log(this.props.t);
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.state);
  }

  handleCertificateDownload = (certNo) => {
    this.props.getCertificate(
      certNo,
      this.onDownloadBegin,
      this.onDownloadSuccess,
      this.onDownloadError
    );
  };

  onDownloadBegin = () => { };
  onDownloadError = (err) => {
    console.log(err);
  };

  onDownloadSuccess = (res, fname) => {
    let a = window.document.createElement("a");
    a.setAttribute("href", URL.createObjectURL(res.data));
    a.setAttribute("target", "_blank");
    a.setAttribute("download", fname);
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  showDetail = (t) => {
    // Eğitim Dökümanları = 10517
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: i18n.t("10517"),
      modalContent: <TrainingDetailDocuments trainingId={t.training.id} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 3:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-tv ">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      case 1:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-live-tv"></span>
          </td>
        );
      default:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-class"></span>
          </td>
        );
    }
  };

  renderCertificationIcon = (t) => {
    if (!t.certificationNo) return null;

    return (
      <SvgDownloadCertificate
        className="training-table__icon-dwncert"
        onClick={() => this.handleCertificateDownload(t.certificationNo)}
      />
    );
  };

  renderDocumentIcon = (t) => {
    if (!t.hasDocument) return null;

    return (
      <SvgViewDocuments
        onClick={() => this.showDetail(t)}
        className="training-table__icon-viewdoc"
      />
    );

    // console.dir(t);
  };

  renderScoreChart = (t) => {
    // console.log(t);
    if (t.score === null) return null;
    let color = "red";
    if (51 <= t.score && t.score < 76) color = "orange";
    if (t.score >= 76) color = "green";
    return (
      <>
        <div
          id="statusCalendarChart_1"
          className="statusCalendarChart"
          data-percent={t.score}
        >
          <div>
            <div className="single-chart">
              <svg viewBox="-2 -2 40 40" className={`circular-chart ${color}`}>
                <path
                  className="circle-bg"
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <path
                  className="circle"
                  strokeDasharray={`${t.score}, 100`}
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <text x="18" y="22.35" className="percentage">
                  {t.score}
                </text>
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  };

  renderTrainingName = (t) => {
    let lang = localStorage.getItem("i18nextLng");
    let trainingName = "";

    if (lang === LANGUAGES.Turkish) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Turkish
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.English) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.English
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Arabic) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Arabic
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.French) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.French
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.German) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.German
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Russian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Russian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Spanish) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Spanish
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Croatian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Croatian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else if (lang === LANGUAGES.Italian) {
      let _trans = t.languageVersions.find(
        (z) => z.languageCode.value === LANGUAGE_CODES.Italian
      );
      trainingName = _trans ? _trans.trainingName : t.training.name;
    } else {
      trainingName = t.training.name;
    }

    return (
      <>
        {t.isRoleTraining && <i className="role-egitim mr-1"></i>}
        {t.isTargetTraining && <i className="hedeflenen-egitim mr-1"></i>}
        {trainingName}
      </>
    );
  };

  renderLanguageVersions = (t) => {
    if (t.languageVersions === null || t.languageVersions.length === 0) {
      return (
        <Dropdown>
          <Dropdown.Toggle size="sm" variant="">
            <React.Fragment>
              <UKFlag className="img-fluid flag" /> EN
            </React.Fragment>
          </Dropdown.Toggle>
        </Dropdown>
      );
    }

    return (
      <Dropdown>
        <Dropdown.Toggle size="sm" variant="">
          {this.state.selectedTrainingLanguage && (
            <React.Fragment>
              {this.getFlag(this.state.selectedTrainingLanguage.value)}{" "}
              {this.state.selectedTrainingLanguage.label}
            </React.Fragment>
          )}
          {!this.state.selectedTrainingLanguage && (
            <React.Fragment>
              <UKFlag className="img-fluid flag" /> EN
            </React.Fragment>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {t.languageVersions.map((item) => (
            <Dropdown.Item
              key={t.key + item.languageVersionId}
              eventKey={item.languageCode.value}
              onSelect={(key, obj) => {
                if (this.trainingNameRef1.current)
                  this.trainingNameRef1.current.innerHTML = item.trainingName;
                if (this.trainingNameRef2.current)
                  this.trainingNameRef2.current.innerHTML = item.trainingName;

                this.setState({
                  selectedTrainingLanguage: item.languageCode,
                });
              }}
            >
              {this.getFlag(item.languageCode.value)} {item.languageCode.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  getFlag = (languageCode) => {
    switch (languageCode) {
      case LANGUAGE_CODES.English:
        return <UKFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Arabic:
        return <UAEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.French:
        return <FRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.German:
        return <DEFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Russian:
        return <RUFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Spanish:
        return <ESFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Turkish:
        return <TRFlag className="img-fluid flag" />;
      case LANGUAGE_CODES.Croatian:
        return <HRFlag className="img-fluid flag" />;
      default:
        return null;
    }
  };

  renderContinueAction = (training) => {
    let url = "";
    let langCode = this.state.selectedTrainingLanguage
      ? this.state.selectedTrainingLanguage.value
      : Helpers.getLangCode(localStorage.getItem("i18nextLng"));
    switch (training.buttonType) {
      case "Play":
        // url = `${SCORMURL}/index?employeeCode=${this.props.employeeCode}&registeredTrainingId=${training.employeeRegisteredTrainingId}&langCode=${langCode}&env=${ENV_NAME}`;
        
          const postUrl = `${SCORMURL}/index?env=${ENV_NAME}`;
        
                const payload = {
                  employeeCode: this.props.employeeCode,
                  registeredTrainingId: training.employeeRegisteredTrainingId,
                  langCode: langCode,
                };
        
                url = (
                  <span
                    className="iconmford fo-icon-play-circle-outline"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      const newWindow = window.open(postUrl, "_blank");
        
                      // alıcı hazırım deyince gönder
                      const readyListener = (e) => {
                        if (e.data === "SCORM_READY") {
                          newWindow.postMessage(payload, SCORMURL);
                          window.removeEventListener("message", readyListener);
                        }
                      };
        
                      window.addEventListener("message", readyListener);
                    }}
                  />
                );
        
        
        break;
      case "Redirect":
        url = training.trainingUrl;
        break;
      default:
        url = "";
        break;
    }

    if (training.buttonType === "Play" && training.showPlayButton) {
       return ( 
        <span>  {url} </span> 
      );
      // return (
      //   <a href={url} target="_blank" rel="noopener noreferrer">
      //     <span className="iconmford fo-icon-play-circle-outline"></span>
      //   </a>
      // );
    } else if (
      training.buttonType === "Redirect" &&
      training.method.value !== 3
    ) {
      return (
        <a
          className="btn-redirect"
          href={url ?? "#"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Trans desc="Yönlendir">10543</Trans>
        </a>
      );
    } else {
      return null;
    }
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr>
                <td></td>
                <td>{this.renderLanguageVersions(t)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="5">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Başlangıç">10117</Trans>
                  </div>
                </td>
                <td className="showGrup">{Helpers.renderDate(t.startDate)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Bitiş">10118</Trans>
                  </div>
                </td>
                <td className="showGrup">{Helpers.renderDate(t.endDate)}</td>
              </tr>
              {/* <tr data-dt-row="0" data-dt-column="6">
                <td>
                  <div className="tableTitle">Başarı</div>
                </td>
                <td className="showGrup">{t.isSuccess}</td>
              </tr> */}
              <tr data-dt-row="0" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Puan">10177</Trans>
                  </div>
                </td>
                <td className="showGrup">{this.renderScoreChart(t)}</td>
              </tr>
              <tr data-dt-row="9" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Dokumanlar">10178</Trans>
                  </div>
                </td>
                <td className="u-centered">{this.renderDocumentIcon(t)}</td>
              </tr>
              <tr data-dt-row="9" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Sertifika">10179</Trans>
                  </div>
                </td>
                <td className="u-centered">
                  {this.renderCertificationIcon(t)}
                </td>
              </tr>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Devam">10390</Trans>
                  </div>
                </td>
                <td className="u-centered">
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {this.renderContinueAction(t)}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup" ref={this.trainingNameRef1}>
              {this.renderTrainingName(t)}
            </td>
            <td>{this.renderLanguageVersions(t)}</td>
            <td className="showGrup">{Helpers.renderDate(t.startDate)}</td>
            <td className="showGrup">{Helpers.renderDate(t.endDate)}</td>
            {/* <td className="showGrup">{t.isSuccess}</td> */}
            <td className="showGrup">{this.renderScoreChart(t)}</td>
            <td className="u-centered">{this.renderDocumentIcon(t)}</td>
            <td className="u-centered">{this.renderCertificationIcon(t)}</td>
            <td>{this.renderContinueAction(t)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={this.ToggleChildren}>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup">{this.renderTrainingName(t)}</td>
          </tr>
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal, getCertificate })(
  CompletedTraining
);
